import { PhoneFields } from "../components/phoneFields";
import { validateIBAN } from "../helpers/validations";

export const fields = [
  {
    name: "Name",
    fieldName: "Name",
    isFieldValid: (value) => /^[A-Za-z]+$/.test(value),
    errorMessage: "Name is not valid",
  },
  {
    name: "MiddleName",
    isFieldValid: (value) => /^[A-Za-z]+$/.test(value),
    fieldName: "Middle Name (Optional)",
    errorMessage: "Middle name is not valid",
    isOptional: true,
  },
  {
    name: "LastName",
    fieldName: "Last Name",
    isFieldValid: (value) => /^[A-Za-z]+$/.test(value),
    errorMessage: "Last Name is not valid",
  },
  {
    name: "PhoneNumber",
    fieldName: "Phone Number",
    custumViewComponent: PhoneFields,
    isFieldValid: (value) => value.code && value.phone && `${value.code}${value.phone}`.length <= 15,
    errorMessage: "Phone number format is incorrect",
  },
  {
    name: "Email",
    fieldName: "Email",
    isFieldValid: (value) => /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(value),
    errorMessage: "Email is not valid",
  },
  {
    name: "PersonalIdentificationDocNumber",
    fieldName: "Personal Identification Doc Number",
    isFieldValid: (value) => Boolean(value),
    errorMessage: "Doc number is required",
  },
  {
    name: "BankName",
    fieldName: "Bank Name",
    isFieldValid: (value) => Boolean(value),
    errorMessage: "Bank Name is required",
  },
  {
    name: "IBAN",
    fieldName: "IBAN",
    // isFieldValid: (value) => validateIBAN(value),
    isFieldValid: (value) => Boolean(value),
    errorMessage: "IBAN is not valid",
  },
  {
    name: "BicCode",
    fieldName: "Bic Code",
    isFieldValid: (value) => Boolean(value),
    errorMessage: "Bic Code is required",
  },
];
